import React from "react";
import { BpointClosureBadge } from "./BpointClosureBadge";

export const BillingClosureBadges = ({ state }) => <>
  <BpointClosureBadge closed={state.bpointClosed} invoiceClosed={state.bpointInvoiceClosed} />
  {state.ziClosed && <span className="inline-flex items-center rounded border border-red-200 bg-red-50 px-2 py-1 text-xs font-semibold text-red-700"
    title={state.ziInvoiceClosed ? "Zucchetti/iiPay chiusi in Fatturazione" : "Inserimenti Zucchetti/iiPay chiusi per gli operatori"}>
    Zucchetti/iiPay chiusi
  </span>}
</>;
